import { render } from "./NotificationGroups.vue?vue&type=template&id=17a6a3f9"
import script from "./NotificationGroups.vue?vue&type=script&lang=js"
export * from "./NotificationGroups.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Dev\\Personal\\reethi-inertia\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__